export interface StoryBlok {
  story: {
    content: {
      body: SbBlock[];
    }
  }
}

export interface SbBlock {
  _uid: string;
  component: string;
  ref_id?: string;
  blocks?: SbBlock[];
}

export function reducerMap(blocks: { [id: string]: SbBlock }, block: SbBlock) {
  return {
    ...blocks,
    [block.ref_id || block._uid]: {
      ...block,
      ...(block.component === 'content_group' && { blocks: block.blocks.reduce(reducerMap, {}) })
    }
  }
}